import login from './login.js'
import cookie from './cookie.js'
import genkey from './genkey.js'
import gbk from './gbk.js'
import data from './data.js'
import platform from './platform.js'
import kmui from './kmui.js'
import no_pic from "@/assets/images/no_pic.png";
import behaviorsMonitor from './behaviorsMonitor.js'
import Decimal from 'decimal.js';
import store from '../store/index.js';

export const isWindows = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  return /win32|wow32|win64|wow64/.test(ua)
}

export function isMobile() {
  if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    // 当前设备是移动设备
    return true;
  }
  return false;
}

export function getMainImage(mainImages) {
  let origin = window.location.origin;
  if (origin.includes('localhost')) {
    origin = 'https://scm3.superboss.cc';
  }
  if (Array.isArray(mainImages) && mainImages.length) {
    return `${origin}/api/wx/unAuth/proxy.json?pic=${mainImages[0]}`;
  }
  return no_pic;
}

export function getQueryString(name) {
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  var r = location.href.split('?')[1]?.match(reg);
  if(r!=null)return  decodeURIComponent(r[2]); return null;
}

// 表示数字的正则表达式
export const numberReg = /^-?\d+(\.\d+)?$/; 

/**
 * 代替原生的toFixed
 * @param {number | string} x - The decimal number to convert.
 * @param {number} n - The number of decimal places to keep in the fixed-point number.
 * @return {string} - The fixed-point number with the specified number of decimal places. eg: '1.00'
 */
export function decimalToFixed(x, n, returnNumber) {
  if (!numberReg.test(String(x))) {
    return x;
  }
  x = new Decimal(x);
  if (returnNumber) {
    return Number(x.toFixed(n));
  }
  return x.toFixed(n);
}

/**
 * 金额精度格式化
 * @param {number | string} x - 要格式化的金额 
 * @param {number} n - 保留几位小数 [默认当前登录公司设置的精度] 
 * @param {boolean} returnNumber 是否返回数字类型
 * @returns {number | string} 3.1, '3.10'
 */
export function amountDigitFn(val, n, returnNumber) {
  if (!n && n !== 0) {
    n = store.getters.amountDigit;
  }
  return decimalToFixed(val, n, returnNumber);
};

// 将字符串中每个单词的首字母转换为大写
export function capitalizeFirstLetter(str){
  if (typeof str !== 'string' || str.length === 0) {
      return str; 
  }
  return str.split(/\b(?=[a-z])/).map(word => {
      // 对于每个单词，将首字母转换为大写，其余部分保持不变
      let newWord = word.charAt(0).toUpperCase() + word.slice(1);
      newWord = newWord.trim();
      return newWord;
  }).join(' ');
}

// 铺货容量限制
export function publishLimit(publishNum = 1){
  let dailyPublishLimit = store.getters.dailyPublishLimit;
  let todayPublishedCount = store.getters.todayPublishedCount;
  if(typeof dailyPublishLimit !== 'number' || typeof todayPublishedCount !== 'number'){
    return true
  }
  let curNum = todayPublishedCount + publishNum;
  if(curNum > dailyPublishLimit){
    window._globel_vm.$confirm(`尊敬的用户，本次铺货数量为${publishNum}，将超过您的单日铺货量上限（${dailyPublishLimit}），请购买正式版本使用！`, '提示', {
      confirmButtonText: '我知道了',
      showCancelButton: false,
      type: 'warning',
    }).catch(() => {});
    return false
  }
  return true
}

// 安全的 JSON 序列化，当有多个字段需要序列化时使用此方法,单个字段失败不影响其他字段
export function safeStringify(val, fallback) {
  try {
    return JSON.stringify(val);
  } catch (e) {
    return fallback;
  }
}

// 安全的 JSON 反序列化，当有多个字段需要序列化时使用此方法，单个字段失败不影响其他字段
export function safeParse(val, fallback) {
  try {
    return JSON.parse(val);
  } catch (e) {
    return fallback;
  }
}

export default {
  login,
  cookie,
  genkey,
  gbk,
  data,
  kmui,
  platform,
  behaviorsMonitor,
  amountDigitFn,
  numberReg,
}
